import axios from "axios";

// REACT_APP_BACKEND_URL is baked in at build time. On a custom production
// domain (e.g. pritch.shop) it will point at the original Emergent host
// (https://<app>.emergent.host) which different-origin requests can't reach
// because of CORS. Detect that mismatch in the browser and fall back to
// same-origin paths (`/api/...`) — the Kubernetes ingress routes those to the
// backend just like it does for the preview domain.
const ENV_BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");

const resolveBackendUrl = () => {
  if (typeof window === "undefined") return ENV_BACKEND_URL;
  if (!ENV_BACKEND_URL) return window.location.origin;
  try {
    const envHost = new URL(ENV_BACKEND_URL).host;
    if (envHost && envHost !== window.location.host) {
      // Served from a different origin than the env-baked backend (typical
      // for a custom production domain). Use same-origin to avoid CORS.
      return window.location.origin;
    }
  } catch {
    return window.location.origin;
  }
  return ENV_BACKEND_URL;
};

export const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchProduct = () => api.get("/products/pritch-grip-sock").then((r) => r.data);
export const fetchBundles = () => api.get("/bundles").then((r) => r.data);
export const createCheckout = (payload) => api.post("/checkout/session", payload).then((r) => r.data);
export const getCheckoutStatus = (sessionId) =>
  api.get(`/checkout/status/${sessionId}`).then((r) => r.data);
export const submitTeamOrder = (payload) => api.post("/team-orders", payload).then((r) => r.data);
export const subscribeNewsletter = (email) => api.post("/newsletter", { email }).then((r) => r.data);
export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const fetchSiteSettings = () => api.get("/site/settings").then((r) => r.data);

export const formatPrice = (amount, currency = "GBP") =>
  new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: currency.toUpperCase(),
    minimumFractionDigits: 2,
  }).format(amount);
